export const accounting = {
  "accounting.create": "accounting.create",
  "accounting.changePeriod": "accounting.changePeriod",
  "accounting.setDealerReport": "accounting.setDealerReport",
  "accounting.setDealerReport.confirm": "accounting.setDealerReport.confirm",
  "accounting.setDealerReport.check": "accounting.setDealerReport.check",
  "accounting.deletePeriod": "accounting.deletePeriod",
  "accounting.getDealerReports": "accounting.getDealerReports",
  "accounting.getReportsStatistics": "accounting.getReportsStatistics",
  "accounting.getPeriod": "accounting.getPeriod",
  "accounting.getDealerReport": "accounting.getDealerReport",
  "accounting.getFileDealerReport": "accounting.getFileDealerReport",
  "accounting.getFileDealerMonitoring": "accounting.getFileDealerMonitoring",
  "accounting.getFileDealerConditions": "accounting.getFileDealerConditions",
  "accounting.getFileReportFileColumns": "accounting.getFileReportFileColumns",
} as const;
